/**
 * Loading-state skeletons. We use these (per the spec) instead of spinners
 * for the inbox because animated greyboxes feel less "broken" than spinners
 * when the data finally arrives and reshuffles the layout.
 */
export function InboxSkeleton(): JSX.Element {
  return (
    <ul className="divide-y divide-tg-separator" aria-busy="true" aria-label="Loading inbox">
      {Array.from({ length: 6 }).map((_, i) => (
        <li key={i} className="flex items-center gap-3 px-4 py-3">
          <div className="h-11 w-11 rounded-full bg-tg-secondary-bg animate-pulse-soft" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-32 rounded bg-tg-secondary-bg animate-pulse-soft" />
            <div className="h-3 w-56 rounded bg-tg-secondary-bg animate-pulse-soft" />
          </div>
          <div className="h-3 w-8 rounded bg-tg-secondary-bg animate-pulse-soft" />
        </li>
      ))}
    </ul>
  );
}

export function ThreadSkeleton(): JSX.Element {
  return (
    <div className="space-y-3 p-4" aria-busy="true" aria-label="Loading thread">
      {[160, 220, 100, 200].map((w, i) => (
        <div
          key={i}
          className={`flex ${i % 2 === 0 ? "justify-start" : "justify-end"}`}
        >
          <div
            className="h-9 rounded-2xl bg-tg-secondary-bg animate-pulse-soft"
            style={{ width: w }}
          />
        </div>
      ))}
    </div>
  );
}
